<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            其他退款
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <el-button type="primary" :disabled="disabledRefund" @click.native="toggleModalRefund">退款</el-button>
                    <!-- <el-button type="primary" :disabled="disabledRecord" @click.native="toggleModalRecord">退款记录</el-button> -->
                    <div style="float:right">
                        <el-input  placeholder="请输入老人姓名" v-model="elderlyName" clearable style="margin:0 5px;width:200px"></el-input>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" highlight-current-row @row-click="rowClick" :height="th" border style="width: 100%;">

                        <el-table-column prop="elderlyName" label="姓名"></el-table-column>

                        <el-table-column prop="idCard" label="身份证"></el-table-column>

                        <el-table-column prop="waitPrice"  label="退费总额（元）"></el-table-column>

                        <el-table-column prop="remarks"  label="备注"></el-table-column>

                        <el-table-column prop="refundTime" :formatter="formatterTime" width="180" label="退费时间"></el-table-column>
                        
                        <el-table-column prop="createTime" :formatter="formatterTime" width="180" label="创建时间"></el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>
        <el-dialog title="退费类型" :visible.sync="dialogRefundType" width="350px" top="35vh">
            <el-select v-model="refundType" placeholder="请选择退费类型" style="width:100%">
                <el-option
                    v-for="item in typeValue"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogRefundType = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Page",
        data(){
            return{
                loading:true,
                menuButtonList:null,
                disabledRefund:true,
                disabledRecord:true,
                dialogRefundType:false,
                row:null,
                showModalRecord:false,
                tableData:null,
                status:-1,
                totalItems: 0,
                elderlyName:'',
                pageSize:20,
                currentPage:1,
                supplierCode:'',
                waresTypeCode:'',
                warehouseCode:'',
                th:0,
                SupplierCodeValue:[],
                WaresTypeCodeValue:[],
                warehouseCodeValue:[],
                typeValue:[{value:1,label:"现金"},{value:3,label:"支付宝"},{value:4,label:"微信"}],
                refundType:'',
                status2: [{
                    value: -1,
                    label: '所有状态'
                },{
                    value: 0,
                    label: '正常'
                }, {
                    value: 1,
                    label: '禁用'
                }],
            }
        },
        components:{
            // Record
        },
        created(){
            this.init();
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
             getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
            },
            init(){
                
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },
            toggleModalRecord(){
                this.showModalRecord = !this.showModalRecord;
                this.$refs.myRecord.init();
            },
            toggleModalRefund(){
                this.$confirm('是否为此用户退款？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.dialogRefundType=true
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });          
                });
            },
            submit(){
              this.loading = true
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"WaitRefund/Refund",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        waitRefundCode:this.row.waitRefundCode,
                        refundType:this.refundType
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.dialogRefundType=false
                        this.$message.success('操作成功！')
                        this.getList();
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });  
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading=true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"WaitRefund/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyName:this.elderlyName,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading=false;
                    this.disabledEdit=true;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            rowClick(row){
                this.row=row;
                if(this.menuButtonList.indexOf("退款")!=-1){
                    this.disabledRefund =false;
                }
            },



        }
    }
</script>

<style lang='scss' scoped>

/deep/ .el-table__body tr.current-row>td {
        background: rgb(121, 187, 255);
        color:#fff;
    }

</style>
